module.exports = __webpack_public_path__ + "img/genoma.e0e23df2.jpg";